module.exports = __webpack_public_path__ + "static/media/mySvgOne.5b96baf7.svg";